import { useEffect } from "react";
import PageLayout from "../../components/PageLayout/PageLayout";
import { Button } from "@mui/material";
import { styles } from "./styles";
import { useNavigate } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import { registerMinorSubscription } from "../../services/registerUserService";
import useGetValidAccessToken from "../../hooks/useGetValidAccessToken";

const PricingTable = (): JSX.Element => {
  const navigate = useNavigate();
  const { user } = useAuth0();
  const { getValidAccessToken } = useGetValidAccessToken();
  // get pricingTableId from env variable in ts
  const pricingTableId = process.env.REACT_APP_PRICING_TABLE_ID;
  const publishableKey = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://js.stripe.com/v3/pricing-table.js";
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  const handleSkipButtonClick = async () => {
    await registerMinorSubscription(user?.sub, await getValidAccessToken());
    navigate("/my-tracks?plan=minor");
    navigate(0);
  };

  return (
    <PageLayout>
      <h1 style={styles.selectOptionHeading}>Select a Subscription Option</h1>
      <div>
        <stripe-pricing-table
          pricing-table-id={pricingTableId}
          publishable-key={publishableKey}
          customer-email={user?.email}
        ></stripe-pricing-table>
      </div>
      <div style={styles.minorSubscriptionButtonContainer}>
        <Button sx={styles.skipButton} onClick={handleSkipButtonClick}>
          No thanks I&apos;ll stay on OmMuse Minor (Free Tier)
        </Button>
      </div>
    </PageLayout>
  );
};

export default PricingTable;
